@if (control) {
  @if (!disabled) {
    <div class="text-container">
      <input
        [ariaLabel]="label"
        [formControl]="control"
        [placeholder]="placeholder"
        type="text"
        [autocomplete]="autocomplete"
        (focus)="switchFocus()"
        (focusout)="switchFocus()"
        (beforeinput)="onBeforeInput($event)"
      />
      @if (focused && counter) {
        <div class="charcounter-container">
          <span class="charcounter" [class.exceeded]="maxlength && (control.value?.length ?? 0) > maxlength">
            <span>{{ control.value?.length || "0" }}</span>
            @if (maxlength !== null) {
              <span>/{{ maxlength }}</span>
            }
          </span>
        </div>
      }
    </div>
  } @else {
    <app-template-html [control]="control" [value]="value" />
  }
}
